import { SimpleEntityGridActionCellButton } from "src/app/components/grid/CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";

export default function useTitleIAGridActions(): SimpleEntityGridActionCellButton[] {
    return ["edit", "disable"];
}
